import { BrowserRouter, Route, Routes } from 'react-router-dom';
import LeadGate from 'registration/lead/gate/LeadGate';
import LeadIntro from 'registration/lead/intro/LeadIntro';
import React, { StrictMode } from 'react';

function LeadApp() {
  return (
    <StrictMode>
      <BrowserRouter>
        <Routes>
          <Route path='/register/lead_intro' element={<LeadIntro />} />
          <Route path='/register/lead_gate' element={<LeadGate />} />
        </Routes>
      </BrowserRouter>
    </StrictMode>
  );
}

export default LeadApp;
